var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-mothers_day",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": "MothersDayFoodItem",
          "menu-item-tag-location": "before-title",
        },
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-mothers_day",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": "MothersDayFoodItem",
          "menu-item-tag-location": "before-title",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }